import React from 'react';

import './styles/App.css';
import {createTheme} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles';

import 'dayjs/locale/pt-br';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {ptBR} from '@mui/x-date-pickers/locales';
import {ptBR as corePtBr} from '@mui/material/locale';

import {SnackbarProvider} from 'notistack';

import Box from '@mui/material/Box';

import CvForm from './components/CvForm';


const theme = createTheme(
    {
        palette: {
            primary: {
                main: '#C8181E',
            },
            secondary: {
                main: '#666',
            },
        },
        shape: {
            borderRadius: 0,
        },
        typography: {
            allVariants: {
                color: '#666',
                fontSize: '15px',
                fontFamily: 'Poppins, sans-serif',
                textTransform: 'none',
            },
            h2: {
                color: '#333',
                fontSize: '22px',
                fontWeight: 'bold',
                marginBottom: '35px',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        padding: '10px 20px',
                    },
                },
            },
        },
    },
    ptBR,
    corePtBr,
);

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                dateAdapter={AdapterDayjs}
                adapterLocale={'pt-br'}
            >
                <SnackbarProvider>
                    <Box className={'App'}>
                        <CvForm/>
                    </Box>
                </SnackbarProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default App;
